import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 16C4 15.76 4.08 15.53 4.25 15.34L11.25 7.34C11.44 7.12 11.71 7 12 7C12.29 7 12.56 7.12 12.75 7.34L19.75 15.34C20.01 15.63 20.07 16.05 19.91 16.41C19.75 16.77 19.39 17 19 17H5C4.61 17 4.25 16.77 4.09 16.41C4.03 16.28 4 16.14 4 16Z" fill={ fill || 'currentColor' } />
    </svg>
);
